module.exports = __webpack_public_path__ + "media/images/icons/country_flags/pw-5df27d3f0d819edce100ffa10a59b814.svg";